// IR-1241 — automatic-logout policy ("Define automatic logout").
//
// These constants ARE the definition. To retune the inactivity window, change
// IDLE_TIMEOUT_MS; to change how long the "you're about to be logged out"
// countdown runs, change IDLE_WARNING_MS. Everything downstream (the idle hook,
// the warning dialog copy) derives from these two numbers.
//
// Policy: after IDLE_TIMEOUT_MS of no operator activity, Iris Ops shows a
// countdown modal for the final IDLE_WARNING_MS; if the operator does not act,
// the session is fully logged out (store cleared, React-Query cache cleared,
// redirect to /login with a "session expired" banner).

export const IDLE_TIMEOUT_MS = 60 * 60 * 1000; // 60 minutes of inactivity
export const IDLE_WARNING_MS = 60 * 1000; // final 60-second countdown

// Passive signals that count as "the operator is still here". Kept coarse on
// purpose: mousemove is throttled inside the idle hook so this is cheap.
export const ACTIVITY_EVENTS = [
  "mousedown",
  "mousemove",
  "keydown",
  "scroll",
  "touchstart",
  "click",
] as const;
